/***
 *
 *   Gallery
 *   Stores user's saved images
 *
 **********/

// import React from 'react'
import { CircularProgress } from '@mui/material'
import { useGalleries } from 'components/hooks/galleries'
import { Animate } from 'components/lib'
import GalleryLayout from 'toolComponents/gallery/galleryLayout'

export function Gallery() {
  const {
    galleries,
    galleryItems,
    gallerySearch,
    setGallerySearch,
    selectedGallery,
    setGalleryItems,
    setSelectedGallery,
    fetchItems,
    fetchGalleries,
  } = useGalleries()

  if (galleries.isLoading)
    return (
      <div className='flex h-full w-full items-center justify-center'>
        <CircularProgress className='!text-brand-violet-light' />
      </div>
    )

  return (
    <Animate type='pop'>
      <GalleryLayout
        galleries={galleries}
        refreshGalleries={fetchGalleries}
        selectedGallery={selectedGallery}
        setSelectedGallery={setSelectedGallery}
        galleryItems={galleryItems}
        gallerySearch={gallerySearch}
        setGallerySearch={setGallerySearch}
        setGalleryItems={setGalleryItems}
        fetchItems={fetchItems}
      />
    </Animate>
  )
}
